import { Company, InvoiceCompany } from '../../api/services/company/types.ts'

export const formatDate = (date: string): string => {
  // '2024-06-01' -> '20240601000000'
  const d = new Date(date)
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${yyyy}${mm}${dd}000000`
}

export const getCurrentTimestamp = (): string => {
  const now = new Date()
  const yyyy = now.getFullYear()
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const dd = String(now.getDate()).padStart(2, '0')
  const hh = String(now.getHours()).padStart(2, '0')
  const min = String(now.getMinutes()).padStart(2, '0')
  const ss = String(now.getSeconds()).padStart(2, '0')
  return `${yyyy}${mm}${dd}${hh}${min}${ss}`
}

export const monthsInPeriod = (fromDate: string, toDate: string): number => {
  const from = new Date(fromDate)
  const to = new Date(toDate)

  return (
    (to.getFullYear() - from.getFullYear()) * 12 +
    (to.getMonth() - from.getMonth()) +
    1
  )
}

export const vatSymbol = (rate: number | string): string => {
  const mapping: Record<string, string> = {
    23: 'A',
    8: 'B',
    5: 'C',
    0: 'D',
    zw: 'E'
  }
  const key = String(rate)
  return mapping[key] || 'X' // 'X' - symbol dla nieznanej stawki
}

export const address = (company: InvoiceCompany | Company) => {
  // składa adres z pól
  const addr = [
    company.address1,
    company.address2,
    company.building ? ` ${company.building}` : '',
    company.flat_number ? `/${company.flat_number}` : ''
  ].join('')
  return addr.trim()
}

export const fullAddress = (company: InvoiceCompany | Company) => {
  const addr = [
    company.address1,
    company.address2 ? ` ${company.address2}` : '',
    company.building ? ` ${company.building}` : '',
    company.flat_number ? `/${company.flat_number}` : '',
    company.postal_code ? `, ${company.postal_code}` : '',
    company.city ? ` ${company.city}` : '',
  ].join('')
  return addr.trim()
}
